
import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, Users, Heart, MessageSquare, Church, Search } from "lucide-react";

export const WhoItsForSection = () => {
  const audiences = [
    {
      title: "The Seeker",
      description: "College students navigating faith on campus, finding their way through tough questions and cultural pressure.",
      icon: <Search className="h-8 w-8 text-heaven-gold" />
    },
    {
      title: "The Parent",
      description: "Moms and dads guiding their children through life's big questions about faith, truth, and purpose.",
      icon: <Users className="h-8 w-8 text-heaven-gold" />
    },
    {
      title: "The New Believer",
      description: "Fresh in faith, hungry to grow, eager to understand the depths of God's Word.",
      icon: <Heart className="h-8 w-8 text-heaven-gold" />
    },
    {
      title: "The Quiet Christian",
      description: "Those yearning to share their faith boldly but needing the right words and confidence.",
      icon: <MessageSquare className="h-8 w-8 text-heaven-gold" />
    },
    {
      title: "The Pastor",
      description: "Ministry leaders seeking fresh tools to equip their congregation for modern challenges.",
      icon: <Church className="h-8 w-8 text-heaven-gold" />
    },
    {
      title: "The Truth Seeker",
      description: "Anyone who loves Scripture and longs to see it transform lives in our digital age.",
      icon: <BookOpen className="h-8 w-8 text-heaven-gold" />
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-[#1A1F2C] mb-6">
            Who It's For
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            From seekers to servants, Selah speaks to every heart that hungers for truth.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {audiences.map((audience, index) => (
            <motion.div
              key={audience.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="h-full border border-gray-100 shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="pt-6">
                  <div className="flex justify-center mb-4">
                    {audience.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-center mb-3">{audience.title}</h3>
                  <p className="text-gray-700 text-center">{audience.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-lg text-gray-700 font-medium">
            If you love the Bible, want to know Christ more, and care about souls—Selah is for you.
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <img 
            src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about%204.png" 
            alt="Selah Community" 
            className="rounded-xl shadow-lg max-w-3xl mx-auto w-full sm:max-w-full sm:w-full object-cover sm:object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};
